<template>
  <div class="chart_warp">
    <div class="chart_tool active" :class="{ topUp: chartName.indexOf('goods_detail') > -1 }">
      <el-button class="def_btn tool_icon_btn" plain size="small" icon="el-icon-full-screen" :disabled="showEmpty" @click="fullScreen">
      </el-button>
    </div>
    <div class="chart_cont" :ref="'bar_' + chartName"></div>
    <div class="empty_tips" v-if="showEmpty">暂无数据</div>
    <!-- 全屏显示图表 -->
    <el-dialog :title="dialogTitle" custom-class="big_dialog" :class="['dialog_' + chartName]" :visible.sync="fullVisible"
      :fullscreen="true" top="0">
      <div class="chart_cont" :ref="'full_bar_' + chartName"></div>
    </el-dialog>
    <div class="text_tips" ref="textTips" v-if="showTextTips">{{ textValue }}</div>
  </div>
</template>

<script>
import { changeNum, setColor } from '@/api/portrait.js'

export default {
  data() {
    return {
      myChart: null,
      fullVisible: false,
      fullH: null,
      chartName: '',
      dialogTitle: '',
      showTextTips: false,
      showEmpty: false,
      textValue: '',
      fullOffset: 0,
      option: {
        color: ['#4FA1A4'],
        // legend: {
        //     top: 20,
        //     right: 20,
        //     itemWidth: 12,
        //     itemHeight: 12,
        //     textStyle: {
        //         color: '#666',
        //     }
        // },
        tooltip: { // 鼠标悬浮提示框显示 X和Y 轴数据
          trigger: 'axis',
          backgroundColor: 'rgba(32, 33, 36,.7)',
          borderColor: 'rgba(32, 33, 36,0.20)',
          borderWidth: 1,
          textStyle: { // 文字提示样式
            color: '#fff',
            fontSize: '12'
          },
        },
        grid: {
          left: 0,
          top: 0,
          right: 50,
          bottom: 0
        },
        xAxis: {
          show: false,
          type: 'value'
        },
        yAxis: [
          {
            type: 'category',
            triggerEvent: true,
            inverse: true,
            position: 'left',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              color: '#666',
              interval: 0,
            },
            animationDuration: 0,
            animationDurationUpdate: 300,
            data: [],
          },
          {
            type: 'category',
            inverse: true,
            position: 'right',
            axisLabel: {
              color: '#666',
              align: 'right',
              interval: 0,
            },
            axisLine: {
              show: false
            },
            axisTick: { show: false },
            data: [],
          },
        ],
        series: [
          {
            realtimeSort: true,
            type: 'bar',
            barMaxWidth: 40,
            data: [],
            showBackground: true,
          }
        ],
        animationDuration: 100,
        animationDurationUpdate: 0,
        animationEasing: 'linear',
        animationEasingUpdate: 'linear',
        dataZoom: [
          {
            type: 'slider',
            yAxisIndex: [0, 1],
            // 数据窗口范围的起始百分比。范围是：0 ~ 100。表示 0% ~ 100%
            // 也可以用 startValue设置起始值
            start: 0,
            end: 100,
            width: 4,
            maxValueSpan: 9, // 显示数据的条数
            borderColor: "#E1E1E1",//滚动条边框颜色
            fillerColor: "#E1E1E1", // 滚动条颜色
            backgroundColor: '#fff',//两边未选中的滑动条区域的颜色
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 是否在 dataZoom-silder 组件中显示数据阴影。数据阴影可以简单地反应数据走势。
            showDataShadow: false,
            brushSelect: false, // 滚动条刷选功能
            throttle: 0
          },
          {
            type: 'inside',
            yAxisIndex: [0, 1],
            start: 0,
            end: 100,
            // 不按任何功能键，鼠标滚轮能触发缩放
            zoomOnMouseWheel: false,
            // 不按任何功能键，鼠标移动能触发数据窗口平移
            moveOnMouseWheel: true,
          }
        ]
      }
    }
  },
  beforeDestroy() {
    this.myChart && this.myChart.clear()
  },
  methods: {
    setOption(val) {
      let yData = []
      let sData = []
      let numList = []
      let len = 0
      let offset = 0
      let data = val
      if (data.length) {
        this.showEmpty = false;
        data.map(item => {
          if (this.chartName.indexOf('goods') > -1) {
            this.dialogTitle = '热门商品'
            if (this.chartName == 'goods+detail') {
              this.option.title = '采购数量'
            }

            yData.push({ value: item.productName })
            sData.push({ value: changeNum(item.purchaseAmt) })
            numList.push(item.purchaseAmt)
            len = item.productName.replace(/[\u0391-\uFFE5]/g, 'aa').length
          } else {
            yData.push({ value: item.areaName })
            len = item.areaName.replace(/[\u0391-\uFFE5]/g, 'aa').length
            if (item.type == 1) {
              sData.push({ code: item.areaCode, value: changeNum(item.medBrokerNum) })
              this.dialogTitle = '服务人员数量'
              numList.push(item.medBrokerNum)
            } else if (item.type == 2) {
              sData.push({ code: item.areaCode, value: changeNum(item.terminalNum) })
              this.dialogTitle = '终端数量'
              numList.push(item.terminalNum)
            } else if (item.type == 3) {
              sData.push({ code: item.areaCode, value: changeNum(item.channelNum) })
              this.dialogTitle = '渠道数量'
              numList.push(item.channelNum)
            }
          }

          offset = len * 6 - offset > 0 ? len * 6 : offset
        })
        this.fullOffset = offset * 0.15
      } else {
        this.showEmpty = true;
      }

      this.option.yAxis[0].data = yData
      this.option.yAxis[1].data = sData
      this.option.series[0].data = numList

      this.$nextTick(() => {
        this.fullVisible ? this.loadChart('full_bar_' + this.chartName) : this.loadChart('bar_' + this.chartName)
      })
    },
    loadChart(chartId) {
      let chartDom = this.$refs[chartId];
      this.myChart = this.$echarts.init(chartDom);
      this.myChart.off('click')  // 解决重复点击
      this.myChart.off('mouseover')
      this.myChart.off('mouseout')
      let sl = this.option.series[0].data.length
      let sh = 260
      if (this.fullVisible) {
        this.option.grid.left = 0
        this.option.grid.containLabel = true
        this.option.yAxis[0].axisLabel.align = 'right'
        this.option.yAxis[0].axisLabel.margin = this.fullOffset
        this.option.yAxis[0].axisLabel.formatter = function (value) {
          return value
        }
        this.option.yAxis[1].axisLabel.align = 'left'
        this.option.yAxis[1].axisLabel.margin = 10
        let maxValueSpan = Math.floor(this.fullH / 46)
        this.option.dataZoom[0].show = this.option.yAxis[0].data.length > maxValueSpan
        this.option.dataZoom[0].maxValueSpan = maxValueSpan
        this.option.dataZoom[1].moveOnMouseWheel = true
        this.option.series[0].barWidth = 26
        sh = sl >= maxValueSpan ? this.fullH : sl * 46
      } else {
        let marginL = 0, marginR = 0
        let warpLen = this.chartName.indexOf('goods') > -1 ? 14 : 10
        this.option.yAxis[0].data.map((item, index) => {
          if (index < 10) {
            let len = item.value.replace(/[\u0391-\uFFE5]/g, 'aa').length
            let ml = len > warpLen ? warpLen * 6 : len * 6
            marginL = ml - marginL > 0 ? ml : marginL
          }
        })
        this.option.yAxis[1].data.map((item, index) => {
          if (index < 10) {
            let len = item.value.replace(/[\u0391-\uFFE5]/g, 'aa').length
            let ml = len > warpLen ? warpLen * 6 : len * 6
            marginR = ml - marginR > 0 ? ml : marginR
          }
        })

        this.option.grid.left = marginL + 15
        this.option.grid.containLabel = false
        this.option.dataZoom[0].maxValueSpan = 9
        this.option.yAxis[0].axisLabel.align = 'left'
        this.option.yAxis[0].axisLabel.margin = marginL + 15
        this.option.yAxis[1].axisLabel.align = 'left'
        this.option.yAxis[1].axisLabel.margin = - (marginR * 0.05) + 10
        this.option.yAxis[0].axisLabel.formatter = function (value) {
          let len = value.replace(/[\u0391-\uFFE5]/g, 'aa').length
          let labelValue = value
          if (warpLen == 10) {
            labelValue = len > warpLen ? `${value.slice(0, warpLen / 2)}\n${value.slice(warpLen / 2)}` : value
          } else {
            if (len > warpLen && len <= 2 * warpLen) {
              labelValue = len > warpLen ? `${value.slice(0, warpLen / 2)}\n${value.slice(warpLen / 2)}` : value
            } else if (len > 2 * warpLen) {
              labelValue = len > 2 * warpLen ? `${value.slice(0, warpLen / 2)}\n${value.slice(warpLen / 2, warpLen)}...` : `${value.slice(0, warpLen / 2)}\n${value.slice(warpLen / 2)}`
            }
          }
          return labelValue
        }
        this.option.dataZoom[0].show = false
        this.option.dataZoom[1].moveOnMouseWheel = false
        this.option.series[0].barWidth = 10
        sh = sl >= 10 ? 10 * 26 : sl * 26
        if (this.chartName != 'goods_detail') {
          this.$emit('setCon', chartDom, sh)
        } else {
          this.option.series[0].barWidth = 14
          sh = sl >= 10 ? 10 * 30 : sl * 30
        }
      }
      chartDom.style.height = sh + 'px'
      this.myChart.resize({
        height: sh
      });
      if (this.showEmpty) return
      this.myChart.setOption(this.option);
      if (this.fullVisible) {
        this.$nextTick(() => {
          let dom = document.querySelectorAll('.v-modal')
          if (dom.length > 0) {
            dom[0].style.zIndex = 'unset'
          }
        })
      }

      let _this = this
      if (this.chartName.indexOf('goods') == -1 && !this.fullVisible) {
        this.myChart.on('click', function (params) {
          let data = null
          if (params.componentType == 'yAxis') {
            let anid = params.event.target.anid
            let dataIndex = Number(anid.split('_')[1])
            data = _this.option.yAxis[1].data[dataIndex]
            data.name = params.value
          } else if (params.componentType == 'series') {
            data = _this.option.yAxis[1].data[params.dataIndex]
            data.name = params.name
          }
          _this.$emit('setMap', data)
        });
      }
      if (!this.fullVisible) {
        this.myChart.on('mouseover', function (params) {
          if (params.componentType == 'yAxis') {
            if (_this.fullVisible) {
              return
            } else {
              _this.textValue = params.value
              let anidP = params.event.target.position
              _this.showTextTips = true
              _this.$nextTick(() => {
                _this.$refs.textTips.style.top = (anidP[1] - 13) + 'px'
              })
            }
          }
        });
        this.myChart.on('mouseout', function (params) {
          if (params.componentType == 'yAxis') {
            if (_this.fullVisible) {
              return
            } else {
              _this.showTextTips = false
              _this.textValue = ''
            }
          }
        });
      }

    },
    fullScreen() {
      this.fullVisible = true
      this.$nextTick(() => {
        let fullDom = document.querySelectorAll('.dialog_' + this.chartName + ' .el-dialog__body')
        if (fullDom.length) {
          this.fullH = fullDom[0].offsetHeight - 80
        }
        this.loadChart('full_bar_' + this.chartName)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.chart_warp {
  width: 100%;
  height: 100%;
  min-height: 80px;
  position: relative;

  .chart_tool {
    width: 100%;
    position: absolute;
    top: -2rem;
    right: 0;
    z-index: 1;

    /deep/.el-button {
      position: absolute;
      right: 0;

      &.tool_icon_btn {
        right: unset;
        left: 0;
        padding: 0;
        width: 32px;
        height: 32px;

        i {
          font-size: 20px;
        }
      }
    }

    &.topUp {
      top: -3rem;
      right: 0rem;
    }

    &.active {
      /deep/.el-button {
        border-color: #666;
        color: #666;

        &.tool_icon_btn {
          width: 24px;
          height: 24px;
          left: unset;
          right: 0;

          i {
            font-size: 16px;
          }
        }
      }
    }
  }

  .chart_cont {
    width: 100%;
    height: 100%;
  }

  .text_tips {
    position: absolute;
    top: 0;
    left: 60px;
    padding: 5px;
    background: rgba(0, 0, 0, .5);
    color: #fff;
    font-size: 12px;
    border-radius: 4px;

    &.active {
      left: 80px;
    }
  }

  .empty_tips {
    font-size: 14px;
    color: #999;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

/deep/.el-dialog {
  &.big_dialog {
    height: 100%;
    margin: 0;

    .el-dialog__header {
      padding: 10px;
      border-bottom: 1px solid #ddd;

      .el-dialog__headerbtn {
        top: 15px;
      }
    }

    .el-dialog__body {
      padding: 40px;
      height: calc(100% - 125px);
    }
  }
}
</style>
